var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.009,
    height: 17.76,
    viewBox: "0 0 16.009 17.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf-svgrepo-com",
    transform: "translate(-3 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_6001",
    "data-name": "Tracciato 6001",
    d: "M4,3.876A.876.876,0,0,1,4.876,3h8.393a.876.876,0,0,1,.619.256l3.865,3.865a.876.876,0,0,1,.256.619V17.884a.876.876,0,0,1-.876.876H4.876A.876.876,0,0,1,4,17.884Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#B91F26",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_6002",
    "data-name": "Tracciato 6002",
    d: "M19.378,7.378H15V3",
    transform: "translate(-1.369 0)",
    fill: "none",
    stroke: "#B91F26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_6003",
    "data-name": "Tracciato 6003",
    d: "M11.438,13H11v3.5h.438a1.751,1.751,0,0,0,0-3.5Z",
    transform: "translate(-0.871 -1.245)",
    fill: "none",
    stroke: "#B91F26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_6004",
    "data-name": "Tracciato 6004",
    d: "M15.5,16.5V13h1.751",
    transform: "translate(-1.431 -1.245)",
    fill: "none",
    stroke: "#B91F26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_6005",
    "data-name": "Tracciato 6005",
    d: "M16,15h.876",
    transform: "translate(-1.493 -1.493)",
    fill: "none",
    stroke: "#B91F26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_6006",
    "data-name": "Tracciato 6006",
    d: "M7,16.5V15.189m0,0V13h.657a1.094,1.094,0,0,1,1.094,1.094h0a1.094,1.094,0,0,1-1.094,1.094Z",
    transform: "translate(-0.373 -1.245)",
    fill: "none",
    stroke: "#B91F26",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon-pdf.d88955448e11589919a0bf9097520874.svg";
export { ForwardRef as ReactComponent };